import { render, staticRenderFns } from "./RadioLikeCard.vue?vue&type=template&id=cefe49fc&scoped=true"
import script from "./RadioLikeCard.vue?vue&type=script&lang=js"
export * from "./RadioLikeCard.vue?vue&type=script&lang=js"
import style0 from "./RadioLikeCard.vue?vue&type=style&index=0&id=cefe49fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefe49fc",
  null
  
)

export default component.exports